const HospitalIcon = ({ className = '', color = '#FF9060' }) => {
  return (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        opacity="0.48"
        x="3"
        y="60"
        width="66"
        height="6"
        rx="3"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M63 60V16.6938C63 12.4521 59.2689 9 54.686 9H17.314C12.7311 9 9 12.4521 9 16.6938V60H27V45C27 43.3431 28.3431 42 30 42H42C43.6568 42 45 43.3431 45 45V60H63ZM27 26.9837C27 28.3557 28.1086 29.4338 29.4455 29.4338H33.5543V33.55C33.5543 34.9221 34.663 36.0001 35.9999 36.0001C37.3695 36.0001 38.4456 34.9221 38.4456 33.55V29.4338H42.5543C43.8913 29.4338 45 28.3557 45 26.9837C45 25.6443 43.8913 24.5336 42.5543 24.5336H38.4456V20.4501C38.4456 19.1107 37.3695 18 35.9999 18C34.663 18 33.5543 19.1107 33.5543 20.4501V24.5336H29.4455C28.1086 24.5336 27 25.6443 27 26.9837Z"
        fill={color}
      />
    </svg>
  )
}

export default HospitalIcon
